
$(function (){
    console.log('Landing Loaded!');
    function get_license(id, action) {
        const license_body_place = $(document).find('#license-body-place')
        let feedback
        $.ajax({
            url: '/ajax/save.php',
            type: 'POST',
            data: {
                action: action,
                id: id,
            },
            beforeSend: function () {
                //setLoader()
                license_body_place.modal('show')
            },
            success: function (res) {
                //feedback = JSON.parse(res)
                feedback = res
            },
            complete: function () {
                license_body_place.find('.license-display').html(feedback)
            }
        })
    }

    $(document).on('hidden.bs.modal', 'license-body-place', function (){
        $(this).find('.license-display').html('')
    })


    $(document).on('click', '.save-license', function(){

        const license_body = $(this).parents('#license-body-place').find('.license-body');
        let license_id = license_body.attr('data-id');

        const opt = {
            margin: 0,
            filename: 'license-number ('+license_id+').pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 2, useCORS: true },
            jsPDF: {unit: 'mm', format: 'A4', orientation: 'landscape', isInputRtl: true, isOutputRtl: true}
        };
        html2pdf().from(license_body[0]).set(opt).save();
    })

    /*const toDataURL = url => fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
        }))


    toDataURL('https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0')
        .then(dataUrl => {
            console.log('RESULT:', dataUrl)
        })*/

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    const alertPlaceholder = $('#liveAlertPlaceholder')
    const appendAlert = (message, type) => {
        const wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('')

        alertPlaceholder.html(wrapper)
    }

    $(document).on('focus', '#username, #password', function (){
        $(document).on('keyup', function(e) {
            if (e.key === 'Enter') {
                $(document).find('#login-now').trigger('click')
            }
        });
    })

    $(document).on('change', '[data-checkable=status]', function (){
        if($(this).is(':checked')) {
            $(this).val(2).removeAttr('checked')
        } else {
            $(this).val(1)
        }
    })

    $(document).on('click', '[data-save=true]', function (){
        const $this = $(this)
        const alert_config = {
            success: {
                color: '#0a3622',
                background: '#B3E2A7'
            },
            error: {
                color: '#58151c',
                background: '#f8d7da'
            },
            warning: {
                color: '#664d03',
                background: '#fff3cd'
            },
            info: {
                color: '#055160',
                background: '#cff4fc'
            }
        }
        let data = {}
        data['action'] = $this.attr('data-action');
        $('[data-form='+$this.attr('data-target-form')+'] [data-fillable]').map((index, element) => {
            const key = $(element).attr('data-fillable')
            data[key] = $(element).val();
        })
        $('[data-form='+$this.attr('data-target-form')+'] [data-checkable]').map((index, element) => {
            const key = $(element).attr('data-checkable')
            data[key] = $(element).val();
        })

        let feedback
        $.ajax({
            url: "/ajax/save.php",
            type: "POST",
            data: data,
            beforeSend: function () {
                $this.prop("disabled", true).find("span").toggleClass("d-none")
            },
            success: (response) => {
                feedback = JSON.parse(response)
            },
            complete: function (){
                $this.prop("disabled", false).find("span").toggleClass("d-none")
                let alert_type = feedback.message_type
                alertPlaceholder.html('')
                $(document).find(".input-feedback-message").add("d-none").text('')
                if (feedback.errors.length !== 0) {
                    alert_type = 'danger'
                    $.each(feedback.errors, function (i, v){
                        let el = $('[data-form='+$this.attr('data-target-form')+']').find(`label[for='${i}']`)
                        el.parent().find(".input-feedback-message").removeClass("d-none").text(v)
                    })
                } else {
                    if($this.attr('data-action')!=='edit-org'){
                        $(document).find('input').val('')
                        $(document).find('select').val('')
                    } else {
                        let input = $(document).find('[data-input=customers--search]').val()
                            getCustomers(input);
                        swal.fire({
                            toast: true,
                            position: 'top',
                            background: alert_config[feedback.message_type].background,
                            color: alert_config[feedback.message_type].color,
                            text: feedback.message,
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false
                        })
                        $this.parents('.modal').modal('hide')
                    }

                    if(feedback.head_to){
                        window.location = feedback.head_to
                    }
                    feedback.popmsg && swal.fire({
                        text: feedback.popmsg
                    })
                }
                appendAlert(feedback.message, alert_type)
            }
        })
    })

    $(document).on('click', '[data-action="get-license"]', function (){

        let $this = $(this),
            action = $this.attr('data-action'),
            id =$this.attr('data-id')
        get_license(id, action)
    })

    $(document).on('click', '#license-search', function(){

        let id = $(document).find('#license-id-search').val()
        console.log(id)
        get_license(id, 'get-license')
    })


    $(document).on('keyup paste', '[data-input=customers--search]' , function(e) {
        let input
        if(e.type === 'paste') {
            input = e.originalEvent.clipboardData.getData("text");
        } else {
            input = $(this).val()
        }
        getCustomers(input);
    })

    function getCustomers(input, page=1) {
        let feedback,
            formData = new FormData(),
            $results_wrapper = $(document).find('#customers--results--wrapper'),
            $statistics_wrapper = $(document).find('#customers--statistics--wrapper'),
            $input = input,
            filters = {
                "q": $input
            };

        formData.append("filters", JSON.stringify(filters));
        formData.append("page", page);
        formData.append("action", '');

        $.ajax({
            url: '/ajax/licenses-filter.php',
            type: 'POST',
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function (){
                //setLoader()
            },
            success: function (res){
                feedback = JSON.parse(res)
            },
            complete: function() {
                $statistics_wrapper.html(feedback.statistics)
                $results_wrapper.html(feedback.licenses);
            }
        })
    }
})